import { makeStyles } from 'tss-react/mui';

export const rightBarIconsStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    // Style the MUI IconButton to match shadcn's minimal look
    '& .MuiIconButton-root': {
      borderRadius: 6,
      padding: 6,
      transition: 'background-color 0.15s ease',
      '&:hover': {
        backgroundColor: 'hsl(240 4.8% 95.9%)',
      },
    },
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(2),
    },
  },
  pointsPill: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    padding: '4px 10px',
    borderRadius: 20,
    border: `1.5px solid ${theme.palette.success.main}`,
    color: theme.palette.success.main,
    fontSize: '13px',
    fontWeight: 600,
    fontFamily: 'Inter, sans-serif',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: `${theme.palette.success.main}10`,
    },
  },
}));
